import { useEffect } from 'react';
import { errorLogger } from '../services/errorLogger';

export const useGlobalErrorHandler = () => {
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      errorLogger.error('Unhandled Error', {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        error: event.error
      });
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      errorLogger.error('Unhandled Promise Rejection', {
        reason: event.reason,
        promise: event.promise
      });
    };

    const handleBeforeUnload = () => {
      // Salvar logs antes de sair da página
      errorLogger.getLogs();
    };

    // Capturar erros de JavaScript
    window.addEventListener('error', handleError);
    
    // Capturar rejeições de Promise não tratadas
    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    
    // Salvar logs antes de sair da página
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
};
